/* unplugin-vue-components disabled */import script from "./ActionScreen.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionScreen.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__